// @mui material components
import { Badge, Icon, Tooltip } from '@mui/material';
import IconButton from "@mui/material/IconButton";
// Material Dashboard 2 PRO React components
import { MDBox } from '../MDBox';
import { MDTypography } from '../MDTypography';
import { IRowAction } from './RowAction';

interface IActionsCellProps {
  actions: IRowAction[],
}

export function ActionsCellWithBadge({
  actions
}: IActionsCellProps) {
  return (
    <MDBox display="flex" justifyContent="center" alignItems="center" px={0}>
      {actions.map((action, index) => (
            <IconButton onClick={() => action.action!(action.key)} key={index}>
            <Tooltip title={action.label}>
                <MDTypography variant="caption" color={action.icon!.color} lineHeight={1} sx={{ cursor: action.disabled ? "not-allowed": "pointer", mx: 0 }}>
                <Badge badgeContent={action.badgeCount} color="info" sx={{zIndex: 0}}>
                    <Icon color="inherit" fontSize="small">{action.icon?.name}</Icon>
                </Badge>
                </MDTypography>
            </Tooltip>
            </IconButton>
      ))}
    </MDBox >
  )
}
